import { produce } from 'immer';

import { UpdateInternalProductsPageStatus } from '../../../actions/products/internal/updateInternalProductsPageStatus';
import { ProductsState } from '../../../typings/products';

export function updateInternalProductsPageStatus(
    state: ProductsState,
    action: UpdateInternalProductsPageStatus
): ProductsState {
    return produce(state, draft => {
        draft.pageStatus = action.status;
    });
}
